import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Card } from 'antd'
import { ErrorHandlerUtils } from 'utils'
import { SettingService } from 'services'
import HtmlRender from '../HtmlRender'
import { LoadingIndicator } from '../misc'

// keep a ?version= page (a previous version referenced by the current documents) out of search results
const useNoIndex = (isEnabled) => {
  useEffect(() => {
    if (!isEnabled) return undefined
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex'
    document.head.appendChild(meta)
    return () => meta.remove()
  }, [isEnabled])
}

// Terms of use / Privacy policy page, the backend resolves which version to show
const PolicyPage = ({ locale, type, title }) => {
  const { search } = useLocation()
  const version = new URLSearchParams(search).get('version')
  const [isLoadingShown, setIsLoadingShown] = useState(false)
  const [data, setData] = useState(null)

  useNoIndex(!!version)

  useEffect(() => {
    setIsLoadingShown(true)
    // type must be in SETTING_CONTENT_TYPE
    SettingService.getContent(version ? { locale, type, version } : { locale, type })
      .then((res) => {
        setIsLoadingShown(false)
        setData(res.value)
      })
      .catch((error) => {
        setIsLoadingShown(false)
        ErrorHandlerUtils.http(error)
      })
  }, [locale, type, version])

  return (
    <div className="full-width background-white p-t-10 p-b-10">
      <div className="center-content">
        <div className="typography-subtitle-bold m-t-40 m-b-40 ta-center">{title}</div>
        <LoadingIndicator isHidden={!isLoadingShown}>
          <Card className="m-b-40">{data && <HtmlRender htmlData={data} isTrusted />}</Card>
        </LoadingIndicator>
      </div>
    </div>
  )
}

const mapStateToProps = ({ localeReducer: { locale } }) => ({
  locale,
})
export default connect(mapStateToProps)(PolicyPage)
